import { ModalBody, Text, Checkbox, Button, ModalFooter, Flex, Box } from "@chakra-ui/react";
import { ClasswizeModal } from "../ui/Modal";
import React, { useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { usePersistentStore } from "@/stores/v2/persistentStore";

interface Props {
	continue: () => void;
	isOpen: boolean;
	onClose: () => void;
}

export function StudentsAuthReminderModal(props: Props): JSX.Element {
	const { t } = useTranslation();
	const [dontShowAgain, setDontShowAgain] = useState<boolean>(false);

	const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setDontShowAgain(event.target.checked);
	};

	const persistentStore = usePersistentStore();

	function handleSubmit() {
		if (dontShowAgain) {
			persistentStore.setFocusLockDontRemindAgainAboutStudentAuth(true);
		}
		props.continue();
	}

	return (
		<ClasswizeModal isOpen={props.isOpen} title={t("focusLibrary.studentsAuthTitle")} onClose={props.onClose} size={"lg"}>
			<ModalBody>
				<Text>
					<Trans i18nKey="focusLibrary.studentsAuthBody" components={{ bold: <b /> }} />
				</Text>
			</ModalBody>
			<ModalFooter>
				<Flex alignItems={"center"} justifyContent={"space-between"} width={"full"}>
					<Box>
						<Checkbox
							isChecked={dontShowAgain}
							onChange={handleCheckboxChange}
							data-testid="students-auth-reminder-checkbox"
							fontWeight={500}
						>
							{t("focusLibrary.studentsAuthDontRemind")}
						</Checkbox>
					</Box>
					<Button onClick={handleSubmit}>{t("focusLibrary.studentsAuthGotIt")}</Button>
				</Flex>
			</ModalFooter>
		</ClasswizeModal>
	);
}
